import React, { useEffect, useRef, useState } from 'react';

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useLocation, Route, Routes } from "react-router-dom";

import "./app.scss";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Home from "../pages/Home";
import Work from "../pages/Work";
import Reels from "../pages/Reels";
import Team from '../pages/Team';
import Careers from '../pages/Careers';
import ScrollToTop from '../Components/ScrollToTop';
import Error from '../pages/Error';
import Cursor from '../Components/Cursor';

function App() {
  const queryClient = new QueryClient()
  
  // Figure out if current page is the error page. If so, don't render header or footer
  const location = useLocation();
  const isErrorRoute = !['/', '/reels', '/projects', '/team', '/careers'].includes(location.pathname);

  return (
    <>
      {!isErrorRoute && <Header />}
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reels" element={<Reels />} />
          <Route path="/projects" element={<Work />} />
          <Route path="/team" element={<Team />} />
          <Route path="/careers" element={<Careers />} />

          <Route path="*" element={<Error />} />
        </Routes>
      </QueryClientProvider>
      <Cursor />
      <ScrollToTop />
      {!isErrorRoute && <Footer />}
    </>
  );
}

export default App;